export const TDAInit = () => {
    return {type: "TDAInit", payload: "TDAInit"}
}

export const setModel = (model) => {
    return {
        type: "setModel",
        payload: model,
    }
}
export const outputMsg = (msg) => {
    return {
        type: "outputMsg",
        payload: msg,
    }
}
